import React from 'react';
import i18n from 'i18n-js';
import { AnalyticsProvider } from '../../providers';
import { OAuthSection, OAuthButton, Divider } from './styles';

export default function OAuthButtons({ mode = 'login', disabled = false }) {
  const handleTwitchLogin = () => {
    window.location.href = `${process.env.REACT_APP_API_URL}/oauth/twitch/login`;
    AnalyticsProvider.event(mode === 'login' ? 'SIGNIN' : 'SIGNUP', {
      provider: 'twitch',
    });
  };

  const handleGoogleLogin = () => {
    window.location.href = `${process.env.REACT_APP_API_URL}/oauth/google/login`;
    AnalyticsProvider.event(mode === 'login' ? 'SIGNIN' : 'SIGNUP', {
      provider: 'google',
    });
  };

  return (
    <>
      <OAuthSection>
        <OAuthButton
          fullWidth
          onClick={handleTwitchLogin}
          disabled={disabled}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M2.089 0L.525 4.175v16.694h5.736V24h3.132l3.127-3.132h4.695l6.26-6.258V0H2.089zm19.779 13.132l-3.652 3.652h-5.736l-3.127 3.132V16.784H5.221V3.132h16.647v10z" fill="#9146FF"/>
            <path d="M18.968 7.305v5.736h-2.088V7.305h2.088zm-5.736 0v5.736h-2.088V7.305h2.088z" fill="#9146FF"/>
          </svg>
          {i18n.t(`screens.oauth.${mode}.twitch`)}
        </OAuthButton>
        <OAuthButton
          fullWidth
          onClick={handleGoogleLogin}
          disabled={disabled}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
            <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
            <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
            <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
          </svg>
          {i18n.t(`screens.oauth.${mode}.google`)}
        </OAuthButton>
      </OAuthSection>
      <Divider>{i18n.t('screens.oauth.divider')}</Divider>
    </>
  );
}